import { fetchApi, apiClient } from '@/lib/api-client'

export interface CompensationConfig {
  hourlyRate: number
  bonusPerRegistration: number
  maxDistanceMeters: number
}

export const configService = {
  getCompensationConfig: () =>
    fetchApi<CompensationConfig>('/config/compensation', { method: 'GET' }),

  updateCompensationConfig: (config: CompensationConfig, token: string) =>
    apiClient.put<CompensationConfig & { updatedAt: string }>('/config/compensation', config, token),
}
